import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/index",
    name: "",
    component: () => import("../views/index.vue"),
    children: [
      {
        path: "/",
        name: "首页",
        component: () => import("../views/home.vue"),
      },
    ],
  },
  {
    path: "/operating",
    name: "经营决策",
    component: () => import("../views/operating"),
  },

  {
    path: "/production",
    mame: "生产管理",
    component: () => import("../views/production"),
  },
  {
    path: "/farm",
    mame: "数字车间",
    component: () => import("../views/farm"),
  },
  {
    path: "/reg",
    name: "体验页面",
    component: () => import("../views/reg.vue"),
  },
  {
    path: "/manage",
    name: "管理系统",
    component: () => import("../views/manage.vue"),
  },
  {
    path: "/mobile",
    name: "移动办公",
    component: () => import("../views/mobile"),
  },
  {
    path: "/about",
    name: "关于我们",
    component: () => import("../views/about.vue"),
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0;
  next();
});
export default router;
